import { ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { ITeam, IEmployee, Department, IAppointment, AppointmentStatus, IHoliday, IGeneralSettings, AppointmentType, SourceSystem, AppointmentBookingSource, EmployeeJobCode } from '@signal/asp-data-commons';
import { DateTime } from 'luxon';
import { Observable, Subscription } from 'rxjs';
import { Predicate } from '@ngrx/entity';
import { TeamState } from '../../../store/team/team.reducer';
import * as fromActions from '../../../store/settings/settings.actions';
import * as fromEmployeeActions from '../../../store/employee/employee.actions';
import * as fromEmployeeSelectors from '../../../store/employee/employee.selectors';
import * as fromTeamsSelectors from '../../../store/team/team.selectors';
import * as fromSettingSelector from '../../../store/settings/settings.selectors';
import * as fromTeamsActions from '../../../store/team/team.actions';
import * as fromScheduleDashboardSelector from '../../../store/schedule-dashboard/schedule-dashboard.selectors';
import * as fromScheduleDashboardActions from '../../../store/schedule-dashboard/schedule-dashboard.action';
import { SettingsState } from '../../../store/settings/settings.reducer';
import { HoursOfOperation } from '../../../shared/models/settings.model';
import { Store } from '@ngrx/store';
import {  selectHolidays } from '../../../store/holiday/holiday.adapter';
import * as HolidayActions from '../../../store/holiday/holiday.actions';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { IDashboardDetails, ScheduleDashboardState } from '../../../store/schedule-dashboard/schedule-dashboard.reducer';
import { IAvailability, IDateAvailability, IScheduleAvailability } from '@signal/asp-data-commons/lib/interfaces/availability';
import { HolidayState } from '../../../store/holiday/holiday.reducer';
import { debounceTime, map } from 'rxjs/operators';
import { AuthService } from '../../services/auth.service';
import { AspServiceAdminRoles } from '../../services/util.service';
import * as _ from 'lodash';
import * as util from '../../../shared/services/util.service';
import { SubscriptionList } from '../../models/asp.types';
import {environment} from '../../../shared/services/util.service'
import { TranslateService } from '@ngx-translate/core';
import { VehiclesState } from '../../../store/vehicle/vehicle.reducer';
import * as fromVehiclesActions from '../../../store/vehicle/vehicle.actions';
import { MatMenuTrigger } from '@angular/material/menu';

@Component({
  selector: 'app-dashboard-calendar',
  templateUrl: './dashboard-calendar.component.html',
  styleUrls: ['./dashboard-calendar.component.scss']
})
export class DashboardCalendarComponent implements OnInit, OnDestroy {
  @Input() department : Department;
  @Input() refreshTime: string;
  @Output() hoursOfOperationChange: EventEmitter<string> = new EventEmitter<string>();
  @Output() emitAppointmentDetails: EventEmitter<any[]> = new EventEmitter<any[]>();
  selectedMonth: string = this.getCurrentMonthYear();
  viewMode = 'Day';
  isTodaySelected: boolean = false;
  selectedDate: Date = new Date(new Date().setHours(0,0,0,0));
  dateGrabberSelectedDate: Date = new Date(new Date().setHours(0, 0, 0, 0));
  teams$: Observable<ITeam[]>;
  activeAdvisors$: Observable<IEmployee[]>;
  serviceAdvisors$: Observable<IEmployee[]>;
  dealerSettings$: Observable<IGeneralSettings>;
  currentSelection: IScheduleAvailability = {} as IScheduleAvailability;
  dateArray: IScheduleAvailability[] = [];
  holidays$: Observable<IHoliday[]>;
  holidayList: IHoliday[] =[];
  private subscr:Subscription;
  viewType:{key:string,value:string}[]=[];
  dateFormat = 'yyyy-MM-dd';
  monthFormat = 'MMMM yyyy';
  selectedZoom: string;
  slotInterval: number;
  weekdays = ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'];
  teamList: any[] = [];
  advisorList: any[] = [];
  transportList: any[] = [];
  /*if changed here will require change in appointment service also*/
  statusList: {key:string,value:string}[] = [{key:'serviceSchedule.scheduled', value:AppointmentStatus.SCHEDULED},
    { key:'serviceSchedule.allStatus', value: 'All Status'},
    {key: 'serviceSchedule.cancelled', value: AppointmentStatus.CANCELED},
    {key : 'serviceSchedule.completed', value:AppointmentStatus.COMPLETED},
    {key :'serviceSchedule.confirmed', value: AppointmentStatus.CONFIRMED},
    {key :'serviceSchedule.conflict', value: "conflict"}
];
bookingSources: { key: string, value: string }[] = [
  { key: 'serviceSchedule.allSources', value: 'All Appointment Sources' },
{ key: 'otherTexts.customer', value: AppointmentBookingSource.ASP },
{ key: 'otherTexts.dealer', value: AppointmentBookingSource.ASPBDC },
{ key: 'otherTexts.flai', value: AppointmentBookingSource.FLAI }
];
serviceBookingSources: { key: string, value: string }[] = [
    { key: 'DMS', value: AppointmentBookingSource.DMS },
    { key: 'OneApp', value: AppointmentBookingSource.ONEAPP },
    { key: 'OneApp-SP', value: AppointmentBookingSource.ONEAPP_SP }
  ];
  salesBookingSources: { key: string, value: string }[] = [
        { key: 'CRM', value: AppointmentBookingSource.CRM },
        { key: 'MST-C', value: AppointmentBookingSource.MSTC }
  ];

  appointmentTypeList: {key:string,value:string, color: string}[] = [{key:'serviceSchedule.allTypes', value:'All Types', color: ''},
  {key:'serviceSchedule.testDrive', value: AppointmentType.TEST_DRIVE, color: '#AED5EB'} ,
  {key:'serviceSchedule.delivery', value: AppointmentType.DELIVERY, color: '#C9FFF5'}, 
  {key: 'navigation.learning', value: AppointmentType.LEARNING, color: '#F4B8B2'},
  {key: 'navigation.vehicleInquiry', value: AppointmentType.VEHICLE_INQUIRY, color: '#FFDCA3'}]
  slotAvailability$: Observable<IAvailability>;
  slotDateData: IDateAvailability[] = [];
  hoursOfOperation: HoursOfOperation[] = [];
  dealerStartTime: string;
  zoomCount ;
  appointments$: Observable<IAppointment[]>;
  isAppointmentLoading$: Observable<boolean>;
  filterForm: UntypedFormGroup;
  isServiceRole: boolean;
  subs:SubscriptionList = {};
  showDelivery:boolean;
  scheduleView = 'Schedule View';
  dispatchView = 'Dispatch View';
  listView = 'List View';
  allInventoryVehicles : any[];

  constructor(private readonly service: AuthService, private readonly cdref: ChangeDetectorRef, private readonly holidayState: Store<HolidayState>, private readonly fb: UntypedFormBuilder,
    private readonly teamsState: Store<TeamState>, private readonly settingsState: Store<SettingsState>, private readonly scheduleDashboardState: Store<ScheduleDashboardState>, private readonly translate: TranslateService,
    private readonly vehicleState: Store<VehiclesState>) {
        this.showDelivery = environment.showDelivery;
    this.subs.roles = this.service.getEmployeeRoles().subscribe(t => {
        this.isServiceRole = _.every([...AspServiceAdminRoles], (x) => t.indexOf(x) >= 0);
        if (!this.isServiceRole || this.department === 'SALES') {
          this.viewType = [
            { key: 'serviceSchedule.scheduleView', value: this.scheduleView },
            { key: 'serviceSchedule.dispatchView', value: this.dispatchView },
            { key: 'serviceSchedule.listView', value: this.listView }
          ];
        }else {
          this.viewType = [
            { key: 'serviceSchedule.dispatchView', value: this.dispatchView },
            { key: 'serviceSchedule.scheduleView', value: this.scheduleView },
            { key: 'serviceSchedule.listView', value: this.listView }
          ];
        }
      });
    }

  ngOnInit(): void {
    this.filterForm = this.fb.group({
      advisorId: ['ALL'],
      transportId: ['ALL'],
      teamId: ['ALL'],
      status: [AppointmentStatus.SCHEDULED],
      viewType: [''],
      appointmentType : ['All Types'],
      bookingSource: ['All Appointment Sources'],
    });
    if(this.department === Department.PARTS){
          this.viewType = [
            { key: 'serviceSchedule.scheduleView', value: this.scheduleView },
            { key: 'serviceSchedule.listView', value: this.listView }
          ];
    }
    if(this.department === Department.SALES || this.department === Department.PARTS){
      this.filterForm.removeControl('teamId');
      this.bookingSources = [...this.bookingSources, ...this.salesBookingSources];
    }
    if(this.department === Department.SERVICE){
      this.filterForm.removeControl('appointmentType');
      this.bookingSources = [...this.bookingSources, ...this.serviceBookingSources];
    }
    // Generated by Copilot- Start
    this.bookingSources = [...this.bookingSources].sort((a, b) =>
      this.translate.instant(a?.key ?? '').localeCompare(this.translate.instant(b?.key ?? ''), undefined, { sensitivity: 'base' })
    );
    // Generated by Copilot- End
    if (!this.isServiceRole || this.department === Department.PARTS) {
      this.filterForm.get('viewType').patchValue(this.scheduleView);
    } else {
      this.filterForm.get('viewType').patchValue(this.dispatchView);
    }
    this.setUpStore();
    this.initializeSubs();
    this.subscr = this.filterForm.valueChanges
    .pipe(debounceTime(500))
    .subscribe(val => {
      this.onFilterChange(val);
    });

  }

  ngAfterContentChecked() {

    if (!this.cdref['destroyed']) {
      this.cdref.detectChanges();
    }

  }

  onFilterChange(_value: any): void {
    let apptPayload;
    if(this.currentSelection && this.currentSelection.date){
      let startDate = DateTime.fromISO(this.currentSelection.date.toISOString());
      const endDate = DateTime.fromISO(this.currentSelection.date.toISOString()).endOf('week');
      if (this.viewMode === 'Day') {
        apptPayload = { department: this.department, startDate: startDate.toFormat(this.dateFormat), endDate: startDate.toFormat(this.dateFormat), filters: this.filterForm.value, viewMode: this.viewMode };
      } else if (this.viewMode === 'Week') {
        if (startDate.startOf('week').month !== DateTime.fromFormat(this.selectedMonth, this.monthFormat).month) {
          startDate = startDate.startOf('month');
        } else {
          startDate = startDate.startOf('week');
        }
        apptPayload = { department: this.department, startDate: startDate.toFormat(this.dateFormat), endDate: endDate.toFormat(this.dateFormat), filters: this.filterForm.value, viewMode: this.viewMode }
      }
      if (this.viewMode !== 'Month') {
        this.scheduleDashboardState.dispatch(new fromScheduleDashboardActions.LoadScheduleDashboardAppointments(apptPayload));
      }
    }
  }

  getCurrentMonthYear(){
    return DateTime.now().toFormat('MMMM yyyy');
  }

  getDatesBetweenDates() {
    let startDate = DateTime.fromFormat(this.selectedMonth, this.monthFormat).startOf('month').startOf('week');
    let endDate = DateTime.fromFormat(this.selectedMonth, this.monthFormat).endOf('month').endOf('week');
    if(this.slotDateData && this.slotDateData.length > 0){
      startDate = DateTime.fromISO(this.slotDateData[0].date);
      endDate = DateTime.fromISO(this.slotDateData[(this.slotDateData.length - 1)].date);
    }
    let dates = [];
    const dateArr: IScheduleAvailability[] = [];
    const theStartDate = new Date(startDate.toString());
    const theEndDate = new Date(endDate.toString());
    while (theStartDate <= theEndDate) {
      dates = [...dates, new Date(theStartDate)]
      theStartDate.setDate(theStartDate.getDate() + 1)
    }
    dates.forEach(date =>{
      let holIndex = -1;
      const index = this.slotDateData?.findIndex(x=>x.date === DateTime.fromISO(date.toISOString()).toFormat(this.dateFormat));
      const dateArrayIndex = this.dateArray?.findIndex(x=>DateTime.fromISO(x.date.toISOString()).toFormat(this.dateFormat) === DateTime.fromISO(date.toISOString()).toFormat(this.dateFormat));
      if(this.holidayList){
        holIndex = this.holidayList.findIndex(x=>x.holidayDate === DateTime.fromISO(date.toISOString()).toFormat(this.dateFormat))
      }
      let dateObj: IScheduleAvailability = {
        bookedSlots: null,
        bookingPercentage: null,
        bookingPercentageHrs: null,
        date: date,
        noOfSlotsLeft: null,
        noOfHrsLeft: null,
        totalSlots: null,
        totalLaborHour: null,
        bookedLaborHour: null,
        garageEfficiency: null,
      };
      if(index > -1){
        const slotDataVal = this.slotDateData[index];
        const bookedHrs = slotDataVal.bookedLaborHour ? slotDataVal.bookedLaborHour : 0;
        const bookedSlots = slotDataVal.bookedSlots ? slotDataVal.bookedSlots : 0;
        const bookedLabourHrs = slotDataVal.bookedLaborHour ?  parseFloat(slotDataVal.bookedLaborHour.toFixed(2)) : 0;
        const shopHrs = this.hoursOfOperation?.find(x=>x.day.toUpperCase() === this.weekdays[date.getDay()])?.operation;
        const garageEfcny = slotDataVal.garageEfficiency ?  parseFloat(slotDataVal.garageEfficiency.toFixed(2)) : 0;
        dateObj = {
           bookedSlots: bookedSlots,
           bookingPercentage: slotDataVal.totalSlots > 0 && bookedSlots > 0 && holIndex === -1? (bookedSlots / slotDataVal.totalSlots)*100  : (shopHrs !== 'Closed' &&  holIndex === -1 && bookedSlots === 0) ? -2 : (shopHrs !== 'Closed' &&  holIndex === -1) ? -1 : null,
           bookingPercentageHrs: slotDataVal.totalLaborHour > 0 && bookedHrs > 0 && holIndex === -1? (bookedHrs / slotDataVal.totalLaborHour)*100 : (shopHrs !== 'Closed' &&  holIndex === -1 && bookedHrs === 0) ? -2 : (shopHrs !== 'Closed' &&  holIndex === -1) ? -1 : null,
           date: date,
           noOfSlotsLeft: slotDataVal.totalSlots - bookedSlots,
           noOfHrsLeft: parseFloat((slotDataVal.totalLaborHour - bookedHrs).toFixed(2)),
           totalSlots: slotDataVal.totalSlots,
           totalLaborHour: slotDataVal.totalLaborHour,
           bookedLaborHour: bookedLabourHrs,
           garageEfficiency: garageEfcny,
         };
      }
      if(dateArrayIndex > -1){
        this.dateArray[dateArrayIndex] = dateObj;
      }
      else{
        dateArr.push(dateObj);
      }
      
    });
    if (!this.currentSelection?.date && this.slotDateData && this.slotDateData.length > 0) {
      let currentMonthStartDate = new Date((DateTime.fromFormat(this.selectedMonth,this.monthFormat).startOf('month')).toString());
      if(this.getCurrentMonthYear() === this.selectedMonth){
        currentMonthStartDate = this.selectedDate;
      }
      let selectIndex = dateArr.findIndex(x=>x.date.getDate() === currentMonthStartDate.getDate() && x.date.getMonth() === currentMonthStartDate.getMonth()
      && x.date.getFullYear() === currentMonthStartDate.getFullYear());
      selectIndex = selectIndex !== -1 ? selectIndex : 0;
      if(dateArr[selectIndex]){
        this.currentSelection = dateArr[selectIndex];
      }
    }
    if(this.currentSelection && this.currentSelection.date  && this.slotDateData && this.slotDateData.length > 0){
      const monthStartDate = new Date(this.currentSelection.date );

      const setAvailability = dateArr.find(x=>x.date.getDate() === monthStartDate.getDate()
      && monthStartDate.getMonth() === x.date.getMonth() && monthStartDate.getFullYear() === x.date.getFullYear());
      if(setAvailability){
        this.currentSelection = setAvailability;
      }
    }
    if(this.viewMode === 'Month'){
      const monthStartDate = new Date((DateTime.fromFormat(this.selectedMonth, this.monthFormat).startOf('month')).toString());

      const setAvailability = dateArr.find(x=>x.date.getDate() === monthStartDate.getDate()
      && monthStartDate.getMonth() === x.date.getMonth() && monthStartDate.getFullYear() === x.date.getFullYear());
      if(setAvailability){
        this.currentSelection = setAvailability;
      }
    }
    this.updateDashboardDetails();
    this.updateHoursOfOperation();
   if(this.dateArray && dateArr && dateArr.length && this.dateArray.length && this.dateArray[this.dateArray.length-1].date > dateArr[0].date){
    this.dateArray = [...dateArr,...this.dateArray];
    
   }else{
    this.dateArray = [...this.dateArray,...dateArr];
   } 
  }

  updateDashboardDetails(){
    if(this.currentSelection.date){
      if(this.currentSelection.date.getMonth() !== (DateTime.fromFormat(this.selectedMonth, this.monthFormat).month - 1)){
        const date = DateTime.fromFormat(this.selectedMonth, this.monthFormat).startOf('month').toFormat(this.dateFormat);
        const dateObj = new Date(date);
        let selectIndex = this.dateArray.findIndex(x=>x.date.getDate() === dateObj.getDate() && x.date.getMonth() === dateObj.getMonth()
        && x.date.getFullYear() === dateObj.getFullYear());
        selectIndex = selectIndex !== -1 ? selectIndex : 0;
       this.currentSelection = this.dateArray[selectIndex];
      }
      const selectedDate = this.currentSelection ? DateTime.fromISO(this.currentSelection.date.toISOString()) : DateTime.now();
      const startDate = selectedDate.toFormat(this.dateFormat);
      let endDate = startDate;
      if(this.viewMode === 'Month'){
        endDate = DateTime.fromFormat(this.selectedMonth, this.monthFormat).endOf('month').toFormat(this.dateFormat);
      } else if(this.viewMode === 'Week'){
        let checkDate = selectedDate.endOf('week');
        endDate = checkDate.toFormat(this.dateFormat);
        /* *below endDate value can change on month not equal */
        if(checkDate.month !== selectedDate.month){
          endDate = DateTime.fromFormat(this.selectedMonth, this.monthFormat).endOf('month').toFormat(this.dateFormat);
        }
      }
      const payload: IDashboardDetails = { startDate: startDate, endDate: endDate, viewMode: this.viewMode, viewType: this.viewType[1].value, filterValue: this.filterForm.value || {}, selectedDate: selectedDate };
      this.scheduleDashboardState.dispatch(new fromScheduleDashboardActions.UpdateScheduleDashboardDetail({department: this.department, dashboardDetails:payload }))
    }
  }

  updateHoursOfOperation(){
     let hoursOfOp = '';
     let index = -1;

     if(this.currentSelection && this.currentSelection.date){
      if(this.holidayList){
        index = this.holidayList.findIndex(x=>x.holidayDate === DateTime.fromISO(this.currentSelection.date.toISOString()).toFormat(this.dateFormat))
      }
     hoursOfOp = index === -1 ? this.hoursOfOperation?.find(x=>x.day.toUpperCase() === this.weekdays[this.currentSelection.date.getDay()])?.operation  :'Holiday';
     this.hoursOfOperationChange.emit(hoursOfOp);
     }
     this.dealerStartTime = (hoursOfOp && hoursOfOp !== 'Closed' && hoursOfOp !== 'Holiday') ? hoursOfOp.split('-')[0] : '';
  }

  loadPreviousMonth(){
    this.selectedMonth = DateTime.fromFormat(this.selectedMonth, this.monthFormat).plus({month: -1}).toFormat(this.monthFormat);
    this.slotDateData = [];
    this.onDateRangeChange();
    this.getDatesBetweenDates();
  }

  loadNextMonth(){
    this.selectedMonth = DateTime.fromFormat(this.selectedMonth, this.monthFormat).plus({month: 1}).toFormat(this.monthFormat);
    this.slotDateData = [];
    this.onDateRangeChange();
    this.getDatesBetweenDates();
  }

  loadView(mode: string){
    if(mode === 'Today') {
      const today = new Date(new Date().setHours(0, 0, 0, 0));
      this.isTodaySelected = true;
      this.selectedMonth = this.getCurrentMonthYear();
      this.selectedDate = today;
      this.dateGrabberSelectedDate = today;
      this.onDateRangeChange({ date: today } as IScheduleAvailability);
      this.getDatesBetweenDates();
      let selectIndex = this.dateArray.findIndex(x => x.date.getDate() === today.getDate() && x.date.getMonth() === today.getMonth()
        && x.date.getFullYear() === today.getFullYear());
      selectIndex = selectIndex !== -1 ? selectIndex : 0;
      const selectedToday = this.dateArray?.[selectIndex] ?? ({ date: today } as IScheduleAvailability);
      this.currentSelection = selectedToday;
      this.onDateChange(selectedToday);
    } else {
      this.viewMode = mode;
      if(mode === 'Month'){
        this.currentSelection = {} as IScheduleAvailability;
        this.updateDashboardDetails();
        this.filterForm.get('advisorId').patchValue('ALL');
        this.filterForm.get('transportId').patchValue('ALL');
        if(this.department === 'SERVICE'){
          this.filterForm.get('teamId').patchValue('ALL');
        }
        if(this.department === 'SALES' || this.department === 'PARTS'){
          this.filterForm.get('appointmentType').patchValue('All Types');
          }
        this.filterForm.get('status').patchValue('All Status');
        this.filterForm.disable();
      } else if (mode === 'Week') {
        this.filterForm.get('viewType').patchValue(this.scheduleView);
        this.filterForm.enable();
        this.filterForm.controls['viewType'].disable();
      } else { // mode === 'Day'
        this.filterForm.enable();
      }
    }

  }

  onDateRangeChange(event?: IScheduleAvailability){
    this.updateHoursOfOperation();
    let startDate = DateTime.fromFormat(this.selectedMonth, this.monthFormat).startOf('month').startOf('week').toFormat(this.dateFormat);
    let endDate = DateTime.fromFormat(this.selectedMonth, this.monthFormat).endOf('week').endOf('month').toFormat(this.dateFormat);
    if(event && event.date){
      startDate = DateTime.fromISO(event.date.toISOString()).startOf('month').startOf('week').toFormat(this.dateFormat);
      endDate = DateTime.fromISO(event.date.toISOString()).endOf('week').endOf('month').toFormat(this.dateFormat);
    }
    const payload = {department: this.department, startDate:startDate , endDate:endDate};
    if(this.viewMode === 'Month'){
      const startDate = DateTime.fromFormat(this.selectedMonth, this.monthFormat).startOf('month').startOf('week').toFormat(this.dateFormat);
      const endDate = DateTime.fromFormat(this.selectedMonth, this.monthFormat).endOf('week').endOf('month').toFormat(this.dateFormat);
    }
    const startDateIso = new Date(startDate).toISOString();
    const endDateIso = new Date(endDate).toISOString();
    if (this.dateArray.findIndex(x => x?.date?.toISOString() === startDateIso) === -1 &&
      this.dateArray.findIndex(x => x?.date?.toISOString() === endDateIso) === -1) {
      this.scheduleDashboardState.dispatch(new fromScheduleDashboardActions.LoadScheduleDashboardSlot(payload));
    }
  }

  onDateChange(event: IScheduleAvailability){
    
    if(this.slotDateData && this.slotDateData.length > 0){
      this.currentSelection = event;
    }
    if (event?.date) {
      this.dateGrabberSelectedDate = new Date(new Date(event.date).setHours(0, 0, 0, 0));
    }
    this.updateHoursOfOperation();
    let date = DateTime.fromFormat(this.selectedMonth, this.monthFormat).startOf('month').toFormat(this.dateFormat);
    if(event && event.date){
    date = DateTime.fromISO(event.date.toISOString()).toFormat(this.dateFormat);
    this.selectedDate = event.date;
    if(event.date.getMonth() !== (DateTime.fromFormat(this.selectedMonth, this.monthFormat).month - 1)){
    this.selectedMonth = DateTime.fromISO(event.date.toISOString()).toFormat(this.monthFormat);
   
    this.onDateRangeChange(event);
    }
    }
    if(this.viewMode === 'Day'){
    const apptPayload = {department: this.department, startDate:date , endDate:date, filters: this.filterForm.value, viewMode: this.viewMode};
    this.scheduleDashboardState.dispatch(new fromScheduleDashboardActions.LoadScheduleDashboardAppointments(apptPayload));
    }
    if(this.currentSelection.date && (this.currentSelection.date.getDate() !== DateTime.now().day || this.currentSelection.date.getMonth() !== (DateTime.now().month - 1) ||
    this.currentSelection.date.getFullYear() !== DateTime.now().year)){
      this.isTodaySelected = false;
    }
    this.updateDashboardDetails();
  }

  onDateGrabberSelected(date: Date | null, menuTrigger: MatMenuTrigger): void {
    if (!date) {
      return;
    }
    const normalizedDate = new Date(new Date(date).setHours(0, 0, 0, 0));
    this.dateGrabberSelectedDate = normalizedDate;
    const matchedDate = this.dateArray?.find((dateValue) =>
      dateValue?.date?.getDate() === normalizedDate.getDate() &&
      dateValue?.date?.getMonth() === normalizedDate.getMonth() &&
      dateValue?.date?.getFullYear() === normalizedDate.getFullYear()
    );
    this.onDateChange(matchedDate ?? ({ date: normalizedDate } as IScheduleAvailability));
    menuTrigger.closeMenu();
  }

  get daySlots(){
    if(this.currentSelection && this.currentSelection.bookedSlots !== null && this.currentSelection.bookedSlots !== undefined
       && this.currentSelection.totalSlots !== null && this.currentSelection.totalSlots !== undefined) {
      return this.translate.instant('serviceSchedule.dayBookedSlots')+ this.currentSelection.bookedSlots +'/'+this.currentSelection.totalSlots;
    } else {
      return this.translate.instant('serviceSchedule.dayBookedSlots')+'NA';
    }
  }

  get dayHours(){
    if(this.currentSelection && this.currentSelection.bookedLaborHour !== null && this.currentSelection.totalLaborHour !== null
      && this.currentSelection.bookedLaborHour !== undefined && this.currentSelection.totalLaborHour !== undefined) {
      const totalLaborHour=this.currentSelection.totalLaborHour % 1 != 0?this.currentSelection.totalLaborHour.toFixed(2):this.currentSelection.totalLaborHour;
      return this.translate.instant('serviceSchedule.dayBookedHours:')+ this.currentSelection.bookedLaborHour +'/'+totalLaborHour;
    } else {
      return this.translate.instant('serviceSchedule.dayBookedHours:')+'NA';
    }
  }

  get garageEff(){
    if(this.currentSelection && this.currentSelection.garageEfficiency !== null && this.currentSelection.garageEfficiency !== undefined) {
      return this.translate.instant('serviceSchedule.garageEfficiency')+ this.currentSelection.garageEfficiency +'%';
    } else {
      return this.translate.instant('serviceSchedule.garageEfficiency')+'NA';
    }
  }

  setUpStore(){
    const advisorDepartment = this.department === Department.PARTS ? Department.SALES : this.department;
    const activeAdvisorPredicate: Predicate<IEmployee> =
      (e: IEmployee) => e.department === this.department
        && e.jobCode === EmployeeJobCode.ADVISOR
        && e.isActive;
    const holObj = {
      activeYear:new Date().getFullYear().toString(),
      department:this.department,
    }
    this.holidayState.dispatch(new HolidayActions.LoadHolidays(holObj));
    const obj = {
      department: this.department,
    };
    this.settingsState.dispatch(new fromActions.LoadSettings(obj));
    this.teamsState.dispatch(new fromEmployeeActions.LoadEmployees());
    this.teamsState.dispatch(new fromTeamsActions.LoadTeams());
    this.activeAdvisors$ = this.teamsState.select(fromEmployeeSelectors.selectEmployees).pipe(
      map((employees: IEmployee[]) => employees.filter((employee: IEmployee) =>
        employee.department === advisorDepartment
        && employee.jobCode === EmployeeJobCode.ADVISOR
        && employee.isActive
      ))
    );

    if (this.department === Department.SALES || this.department === Department.PARTS) {
      this.vehicleState.dispatch(new fromVehiclesActions.LoadAllVehicles({view: SourceSystem.ME}));
    }
    this.teams$ = this.teamsState.select(fromTeamsSelectors.selectTeams);
    this.dealerSettings$ = this.settingsState.select(fromSettingSelector.selectSettings);
    this.slotAvailability$ = this.scheduleDashboardState.select(fromScheduleDashboardSelector.selectScheduleDashboardSlot, {department: this.department});
    this.holidays$ = this.holidayState.select(selectHolidays);
    this.appointments$ = this.scheduleDashboardState.select(fromScheduleDashboardSelector.selectScheduleDashboardAppointmentsForDay,{department: this.department});
    this.isAppointmentLoading$ = this.scheduleDashboardState.select(fromScheduleDashboardSelector.selectScheduleDashboardLoading);
  }

  zoomTrigger(val: string){
    if(!this.zoomCount){
      this.zoomCount = 60/this.slotInterval;
      this.zoomCount = this.slotInterval === 45 ? 4 : this.slotInterval === 60 ? 2 : this.zoomCount;
    }
    if(val === 'out' && this.zoomCount > 2){
      this.zoomCount = this.zoomCount - 1;
    }else if(val === 'in' && this.zoomCount < 8){
      this.zoomCount = this.zoomCount + 1;
    }
  }

  setAdvisorList(advisorList: IEmployee[]){
    const uniqueList: IEmployee[] = [];
    if (advisorList && advisorList.length > 0) {
    advisorList.forEach(x=> {
      const index = uniqueList.findIndex(y => y.id === x?.id);
      if(index === -1 && x){
        uniqueList.push(x);
      }
    });
  }
  const advisorAdd = [];
    advisorAdd.push({id: 'ALL', name: this.department === Department.SERVICE ? this.translate.instant('serviceSchedule.allServiceAdvisors') : 
    this.translate.instant('serviceSchedule.allSalesAdvisors')});
    this.advisorList = [...advisorAdd, ...uniqueList.map(x => {return {id: x.id, name: x.displayName} as any})];
  }

  initializeSubs(){
    this.subs.activeAdvisors = this.activeAdvisors$.subscribe(advisorData => {
      this.setAdvisorList(advisorData || []);
    });
   this.subs.teams = this.teams$.subscribe(teamData => {
      if(teamData && teamData.length > 0){
        const teamAdd = [];
        teamAdd.push({id: 'ALL', name: this.translate.instant('serviceSchedule.allTeams'),teamColor : ''});
        this.teamList = [...teamAdd, ...teamData.map(x => {return {id: x.id, name: x.name ,teamColor : x.teamColor} as any })];
        this.teamList.push({id:'OTHER', name: this.translate.instant('serviceSchedule.others'),teamColor : '#d1e8ff'});
      } else{
        this.teamList.push({id: 'ALL', name: this.translate.instant('serviceSchedule.allTeams'),teamColor : ''});
      }
    });
   this.subs.settings = this.dealerSettings$.subscribe(settingData => {
      if(settingData && !!settingData.transport){
        const transportAdd = [];
        transportAdd.push({id: 'ALL', name: this.translate.instant('serviceSchedule.allTransportation') });
        this.transportList = [...transportAdd];
        if(settingData?.transport?.transportOptions) {
          const transportOptions = [...(settingData.transport.transportOptions.map(x => { return { id: x.id, name: this.translate.instant(`common.${x.label}`) } as any }) || [])]
          this.transportList.push(...transportOptions)
        }
        this.hoursOfOperation = settingData.time.hoursOfOperation;
        this.slotInterval = settingData.time.slotDuration;
        //this.zoomCount = this.slotInterval;
        this.updateHoursOfOperation();
      }
    });
    this.subs.holiday = this.holidays$.subscribe(holidayList => {
      if(holidayList){
        this.holidayList = holidayList;
      }
    })
   this.subs.availability = this.slotAvailability$.subscribe(slotAvailability => {
      if(slotAvailability && slotAvailability.availableDates){
        this.slotDateData = slotAvailability.availableDates;
        this.getDatesBetweenDates();
      }
    });


  }

  ngOnDestroy() {
    this.vehicleState.dispatch(new fromVehiclesActions.ResetVehicleState());
    this.subscr.unsubscribe();
    util.unsubscribeSubscriptions(this.subs);
    this.cdref.detach();
  }
  emitApptDetails(event){
    this.emitAppointmentDetails.emit(event);
  }

  getMonth(month){
    return month ? `${this.translate.instant(`common.${DateTime.fromFormat(this.selectedMonth, this.monthFormat).toFormat('MMMM')}`)} ${DateTime.
    fromFormat(this.selectedMonth, this.monthFormat).toFormat('yyyy')}` : month;
  }

  loadDateRange(event){
    const date = event.toFormat(this.dateFormat);
    const scheduleEvent = {} as IScheduleAvailability;
    scheduleEvent.date = new Date(date);
    this.onDateRangeChange(scheduleEvent);
  }
}
